import * as React from 'react';

// MUI
import Box from "@mui/material/Box";
import Avatar from '@mui/material/Avatar';
import { green } from '@mui/material/colors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Typography from "@mui/material/Typography";

// Internal
import {PublicationType} from '../data/types';

interface PublicationCardProps {
  publication: PublicationType;
  showContent?: boolean;
  showScrollbar?: boolean;
  hideCoverMedia?: boolean;
}

const getFirstSentence = (html: string): string => {
  const text = html.replace(/<[^>]*>/g, '').trim();
  const match = text.match(/^[^.!?]*[.!?]/);
  return match ? match[0] + '..' : text.slice(0, 120) + '...';
};

function PublicationCard(props: PublicationCardProps) {
  const { publication, hideCoverMedia } = props;
  const hasImage = !hideCoverMedia && !!publication.coverMedia?.url;

  const renderUserInfo = () => (
    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", mt: 1 }}>
      {publication.user.profile.photo?.url
        ? <Avatar sx={{ m: 1, ml: 0 }} alt="userProfile" src={publication.user.profile.photo.url} />
        : <Avatar sx={{ bgcolor: green[500], m: 1, ml: 0 }}><AccountCircleIcon /></Avatar>
      }
      <Typography variant="body2">{publication.user.profile.nickname}</Typography>
    </Box>
  );

  if (hasImage) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <Typography variant="h5" sx={{ mt: 1 }}>{publication.title}</Typography>
        <Box sx={{ width: "100%" }}>
          <img
            alt="coveredMedia"
            src={publication.coverMedia.url}
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </Box>
        {renderUserInfo()}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
      <Typography variant="h5">{publication.title}</Typography>
      {publication.htmlContent && (
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          {getFirstSentence(publication.htmlContent)}
        </Typography>
      )}
      {renderUserInfo()}
    </Box>
  );
}

export default PublicationCard;
